export enum TicketFormField {
	STATUS,
	PRIORITY,
	CATEGORY,
	CC,
	BCC
}
